<script setup lang="ts">

import Modal from "../Modal.vue";

export interface Props {
  hasDiagnosisDateChanged: boolean,
  handleRemoveMedications: () => void,
  handleUndoDateChange: () => void,
}

const props = defineProps<Props>();
</script>
<template>
    <Modal
        id="diagnosis-date-conflict"
        header="Are you sure you want to change your diagnosis date"
        open-focus="diagnosis-date-conflict-modal"
        :show="props.hasDiagnosisDateChanged"
    >
        <template #body>
            <p>Your selected diagnosis date is set to after you started taking medication for this condition, if you continue these medications will be removed.</p>
        </template>
        <template #footer>
            <button
                id="removeMedications"
                type="button"
                class="btn btn-danger font-weight-bold"
                @click.prevent="props.handleRemoveMedications"
            >
                Save date change and remove medication
            </button>
            <button
                id="undoDateChange"
                type="button"
                class="btn btn-primary font-weight-bold"
                @click.prevent="props.handleUndoDateChange"
            >
                Undo date change
            </button>
        </template>
    </Modal>
</template>
